
/**
 *
 * @description Constant reusable variables (for better code structure)
 */

export const SIGN_UP_PAGES = {
    // student
    1: [
        { component: 'StudentAboutYou', title: 'About You' },
        { component: 'FlightSchoolConnect', title: 'Flight School Connect' },
        { component: 'Documents', title: 'Documents' },
        { component: 'FinancingOptions', title: 'Financing Options' },
        { component: 'LenderConnections', title: 'Lender Connections' },
        // V2
        // { component: 'StudentFinanceOptions', title: 'Finance Options' },
        // { component: 'StudentFinanceOffer', title: 'Finance Options' }
    ],
    // instructor
    4: [
        { component: 'InstructorAboutYou', title: 'About You' },
        { component: 'FlightSchoolConnect', title: 'Flight School Connect' },
        { component: 'Documents', title: 'Documents' },
        { component: 'LenderConnections', title: 'Flight School Connections' }
    ],
    // dispatch
    14: [
        { component: 'DispatchAboutYou', title: 'About You' },
        { component: 'FlightSchoolConnect', title: 'Flight School Connect' }
    ],
    // admin
    7: [
        { component: 'AdminAboutYou', title: 'About You' },
        { component: 'FlightSchoolConnect', title: 'About Your School' }
    ],
    // owner
    18: [
        { component: 'OwnerAboutYou', title: 'About You' },
        { component: 'FlightSchoolConnect', title: 'About Your School' },
        { component: 'LenderConnections', title: 'Lender Connections' },
    ],
    // lender
    15: [
        { component: 'LenderAboutYou', title: 'About Your Financial Institution' },
        { component: 'StudentCriteria', title: 'Student Loan Eligibility Criteria' },
        { component: 'FlightSchoolCriteria', title: 'Flight School Eligibility Criteria' },
        { component: 'HiloIntegrations', title: 'Hilo Integrations and Preferences' },
        // { component: 'LenderConnections', title: 'Flight School Connections' }
    ],
    // maintenance
    13: [
        { component: 'MaintenanceAboutYou', title: 'About You' },
        { component: 'LenderConnections', title: 'Flight School Connections' }
    ],
    // dpe
    10: [
        { component: 'DpeAboutYou', title: 'About You' },
        { component: 'Documents', title: 'Documents' },
        { component: 'FlightSchoolConnect', title: 'Flight School Connection' },
        { component: 'LenderConnections', title: 'Connect With More Schools' }
    ],
    // ame
    16: [
        { component: 'AmeAboutYou', title: 'About Your Medical Practice' },
        { component: 'LenderConnections', title: 'Flight School Connections' }
    ],
    // airline
    17: [
        { component: 'AirlineAboutYou', title: 'About Your Airline' },
        { component: 'LenderConnections', title: 'Flight School Connections' }
    ]
};


export const LENDER_CONNECTION_CARD_TITLES = [
    "Venture West Aviation",
    "CAE Flight School",
    "Sierra Charlie Aviation",
    "Take Flight Flight School",
    "Blue Line Aviation",
    "Simplifly Flight School"
];

export const LENDER_CONNECTION_HEADER = {
    4: 'Connect with flight schools looking to hire certified flight instructors.',
    18: 'Connect with lenders looking to work with flight schools like yours.',
    15: 'Connect with flight schools looking to work with lenders like yours.',
    13: 'Connect with flight schools looking to hire maintenance technicians.',
    10: 'Connect with flight schools looking for Designated Pilot Examiners.',
    16: 'Connect with flight schools looking for airline partnerships.',
    17: 'Connect with flight schools looking to place their students at an airline.'
};


// AdminGradeBook.vue
export const ADMIN_GRADEBOOK_TABLE_HEADERS = [
    'Name',
    'Grade',
    'Status',
    // 'Hr',
    'Program',
    'Start',
    'End',
    'Balance',
    // '$ Funded',
    'Profile',
    'Grade Book',
    'Log Book'
];

export const PROGRAMS = [
    { id: 'Private', name: 'Private Pilot' },
    { id: 'Instrument', name: 'Instrument Pilot' },
    { id: 'Commercial', name: 'Commercial Pilot' },
    { id: 'CFI', name: 'Certified Flight Instructor' },
    { id: 'CFII', name: 'Certified Flight Instructor-Instrument' },
    { id: 'Multi', name: 'Commercial Multi Engine' },
];


export const DISPATCHER_POPUPS = [
    { component: 'FlightMainDetails', title: 'Flight Details' },
    { component: 'WeightBalance', title: 'Weight & Balance' },
    { component: 'WeightBalanceEnvelope', title: 'Weight & Balance Envelope' },
    { component: 'FlightOtherDetails', title: 'Flight Details' },
    { component: 'PilotReadinessChecklists', title: 'Pilot Readiness Checklists' },
    { component: 'AircraftMainChecklists', title: 'Aircraft Airworthiness Checklists' },
    // { component: 'AircraftOtherChecklists', title: 'Aircraft Airworthiness Checklists' },
    { component: 'PaveWorksheet', title: 'PAVE Worksheet' },
    { component: 'FlightSummary', title: 'Flight Summary' }
];

export const PILOT_READINESS_SECTIONS = [
    {
      title: 'IMSAFE',
      fields: [
        { model: 'illness', label: 'Illness - No Symptoms' },
        { model: 'medication', label: 'Medication - No Unapproved Drugs' },
        { model: 'stress', label: 'Stress - No Outside Worries' },
        { model: 'alcohol', label: 'Alcohol - 8 hrs / Not Under Influence' },
        { model: 'fatigue', label: 'Fatigue - Well Rested, Not Tired' },
        { model: 'emotions', label: 'Emotions - Not Upset/Angry' }
      ]
    },
    {
      title: 'Currency / Proficiency',
      fields: [
        { model: 'flownWithinWeek', label: 'Flown Within Last 2 Weeks'},
        { model: 'flownWithTailNumber', label: 'Flown With This Tail Number Before' },
        { model: 'isFamiliar', label: 'Familiar With Destination Airport' },
        { model: 'landingsInLast90Days', label: '3 Takeoffs / Landings In Last 90 Days' },
        { model: 'ipcCurrent', label: 'BFR / IPC Current' },
        { model: 'flyingWithCFI', label: 'Flying With CFI' }
      ]
    },
    {
      title: 'External Pressures',
      inline: true,
      fields: [{ model: 'deadline', label: 'Any Deadlines / Pressures / Appointments / Etc.?', placeholder: 'Share here...' }]
    }
];

export const progressColors = [
    { stop: 0, color: "#FE0D02" },
    { stop: 13, color: "#FC5B00" },
    { stop: 25, color: "#FFA000" },
    { stop: 38, color: "#FDD900" },
    { stop: 50, color: "#FDF102" },
    { stop: 63, color: "#D8FF02" },
    { stop: 75, color: "#9FFF02" },
    { stop: 88, color: "#5CFD01" },
    { stop: 100, color: "#13FF02" }
];
